import React from 'react';
const Home = React.lazy(() => import('./Pages/Home'));
const GameDetail = React.lazy(() => import('./Pages/GameDetail'));
const BetHistory = React.lazy(() => import('./Pages/BetHistory'));
const MyBets = React.lazy(() => import('./Pages/BetHistory/MyBets'));
const MyMarkets = React.lazy(() => import('./Pages/BetHistory/MyMarkets'));
const AccountStatement = React.lazy(() => import('./Pages/AccountStatement'));
const Profile = React.lazy(()=> import('./Pages/Profile/Profile') )
const BonusStatement = React.lazy(() => import('./Pages/BonusStatement'));
const StackSetting = React.lazy(() => import('./Pages/StackSetting'));
const ChangePassword = React.lazy(() => import('./Pages/Password'));
const inplay = React.lazy(() => import('./Pages/InPlays'));
const Sports = React.lazy(() => import('./Pages/InPlays/Sports'));
const Casino = React.lazy(() => import('./Pages/Home/Casino'));
const JoinNow = React.lazy(() => import('./Pages/Home/JoinNow'));
const Login = React.lazy(() => import('./Pages/Home/Login'));
const SportsBook = React.lazy(() => import('./Pages/Home/SportsBook'));
const VirtualSports = React.lazy(() => import('./Pages/Home/VirtualSports'));
const CasinoList = React.lazy(() => import('./Pages/Home/CasinoList'));
const DepositWallet = React.lazy(() => import('./Pages/Wallet/Deposit'))
const WithDwarlWallet = React.lazy(() => import('./Pages/Wallet/Withdrawl'))
const AccountDetail = React.lazy(() => import('./Pages/Wallet/AccountDetail'))
const ForgotPassword = React.lazy(()=>import('./Pages/Home/ForgotPassword'))
const GettingStarted = React.lazy(() => import('./Pages/WebPages/GettingStarted'))
const AboutUs = React.lazy(() => import('./Pages/WebPages/AboutUs'))
const Faq = React.lazy(() => import('./Pages/WebPages/Faq'))
const TermsConditions = React.lazy(() => import('./Pages/WebPages/TermsConditions'))
const PrivacyPolicy = React.lazy(() => import('./Pages/WebPages/PrivacyPolicy'))
const Help = React.lazy(() => import('./Pages/WebPages/BettingHelp'))
const ExpousureBets = React.lazy(() => import('./Pages/BetHistory/ExpousureBets'))


const routes = [
    { path: '/', exact: true, name: 'Home', component: Home },
    { path: '/detail/:game_id/:event_id', exact: true, name: 'Game Detail', component: GameDetail },
    { path: '/betHistory', exact: true, name: 'Bet History', component: BetHistory },
    { path: '/myBets/:game_id', exact: true, name: 'Bet History', component: MyBets },
    { path: '/myMarkets', exact: true, name: 'My Markets', component: MyMarkets },
    { path: '/accountStatement', exact: true, name: 'Account Statement', component: AccountStatement },
    { path: '/profile', exact: true, name: 'Profile', component:Profile },
    { path: '/bonusStatement', exact: true, name: 'Account Statement', component: BonusStatement },
    { path: '/stackSetting', exact: true, name: 'Stack Setting', component: StackSetting },
    { path: '/ChangePassword', exact: true, name: 'Change Password', component: ChangePassword },
    { path: '/inplay', exact: true, name: 'inplay', component: inplay },
    { path: '/Sports/:gType', exact: true, name: 'Sports', component: Sports },
    { path: '/virtual-sports/:providerCode/:gameCode', exact: true, name: 'Casino', component: VirtualSports },
    { path: '/sports-book/:providerCode/:gameCode', exact: true, name: 'Casino', component: SportsBook },
    { path: '/Casino/:providerCode/:gameCode', exact: true, name: 'Casino', component: Casino },
    { path: '/join-now', exact: true, name: 'JoinNow', component: JoinNow },
    { path: '/forgotPassword', exact: true, name: 'Forgot Password', component: ForgotPassword },
    { path: '/login', exact: true, name: 'Login', component: Login },
    { path: '/CasinoList', exact: true, name: 'Casino List', component: CasinoList},
    { path: '/wallet/deposit/:value', exact: true, name: 'Deposit Wallet', component: DepositWallet},
    { path: '/wallet/AccountDetail', exact: true, name: 'Bank Account Detail', component: AccountDetail},
    { path: '/wallet/WithDrawl', exact: true, name: 'WithDwarl Wallet', component: WithDwarlWallet},
    { path: '/getting-started', exact: true, name: 'Deposit Wallet', component: GettingStarted},
    { path: '/about-us', exact: true, name: 'Deposit Wallet', component: AboutUs},
    { path: '/faq', exact: true, name: 'Deposit Wallet', component: Faq},
    { path: '/terms-conditions', exact: true, name: 'Deposit Wallet', component: TermsConditions},
    { path: '/privacy-policy', exact: true, name: 'Deposit Wallet', component: PrivacyPolicy},
    { path: '/help', exact: true, name: 'Deposit Wallet', component: Help},
    { path: '/ExpousureBets', exact: true, name: 'Exposurewise Bets List', component: ExpousureBets},
];

export default routes;
